module.exports = hasNextPage;

var deprecate = require('./deprecate');

var getPageLinks = require('./get-page-links');

function hasNextPage(link) {
  deprecate("octokit.hasNextPage() \u2013 You can use octokit.paginate or async iterators instead: https://github.com/octokit/rest.js#pagination.");
  return getPageLinks(link).next;
}